import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { DirectionService } from '../../direction.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DialogService } from 'src/app/dialog/dialog.service';

import { ClustersService } from 'src/app/main-section/choose-branch/clusters.service';

@Component({
  selector: 'app-su-full-inventory',
  templateUrl: './su-full-inventory.component.html',
  styleUrls: ['./su-full-inventory.component.css'],
  host: {
    class: 'fill-screen-modal-new-dialog'
  }
})
export class SuFullInventoryComponent implements OnInit, OnDestroy {
  isRTL: boolean = true;
  private directionSubscription: Subscription;
  isDarkMode: boolean = false;
  isLoading: boolean = false;

  userId: string;
  userIsAuthenticated = false;
  private authStatusSub: Subscription;

  clusters: any[] = [];
  showOnlyMissing: boolean = false;

  constructor(
    private directionService: DirectionService,
    private authService: AuthService,
    private dialogService: DialogService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clustersService: ClustersService,
  ) { }

  async ngOnInit() {
    this.isLoading = true;
    this.directionSubscription = this.directionService.direction$.subscribe(direction => {
      this.isRTL = direction === 'rtl';
    });

    this.directionService.isDarkMode$.subscribe(isDarkMode => {
      this.isDarkMode = isDarkMode;
    });

    this.userId = this.authService.getUserId();
    this.userIsAuthenticated = this.authService.getIsAuth();
    this.authStatusSub = this.authService
      .getAuthStatusListener()
      .subscribe(isAuthenticated => {
        this.userIsAuthenticated = isAuthenticated;
        this.userId = this.authService.getUserId();
      });

    this.clustersService.clustersformaniger().subscribe((clusters) => {
      this.clusters = clusters;
      console.log('clusters', clusters);
      this.isLoading = false;
    });
  }

  closeSuFullInventoryDialog() {
    this.dialogService.onCloseSuFullInventoryDialog();
  }

  toggleShowOnlyMissing() {
    this.showOnlyMissing = !this.showOnlyMissing;
  }

  /**
   * Check if consumables object has any item with quantity <= 0
   */
  hasMissingConsumables(consumables: any): boolean {
    if (!consumables) return false;
    for (const key in consumables) {
      if (consumables.hasOwnProperty(key) && consumables[key] <= 0) {
        return true;
      }
    }
    return false;
  }

  /**
   * Check if branch has any consumable with quantity <= 0
   */
  hasMissingConsumablesInBranch(branch: any): boolean {
    if (!branch || !branch.stockCurrent) return false;
    return this.hasMissingConsumables(branch.stockCurrent.paper) || 
           this.hasMissingConsumables(branch.stockCurrent.ink);
  }

  /**
   * Check if cluster has any branch with missing consumables
   */
  hasMissingConsumablesInCluster(cluster: any): boolean {
    if (!cluster) return false;
    
    // Check plotter branches
    if (cluster.plotter && Array.isArray(cluster.plotter)) {
      for (const branch of cluster.plotter) {
        if (this.hasMissingConsumablesInBranch(branch)) {
          return true;
        }
      }
    }
    
    // Check express branches
    if (cluster.express && Array.isArray(cluster.express)) {
      for (const branch of cluster.express) {
        if (this.hasMissingConsumablesInBranch(branch)) {
          return true;
        }
      }
    }
    
    return false;
  }

  /**
   * Get filtered clusters (only those with missing consumables if filter is active)
   */
  getFilteredClusters(): any[] {
    if (!this.showOnlyMissing) {
      return this.clusters;
    }
    
    return this.clusters.filter(cluster => this.hasMissingConsumablesInCluster(cluster));
  }

  /**
   * Get filtered branches for a cluster (only those with missing consumables if filter is active)
   */
  getFilteredBranches(branches: any[]): any[] {
    if (!this.showOnlyMissing || !branches) {
      return branches || [];
    }
    
    return branches.filter(branch => this.hasMissingConsumablesInBranch(branch));
  }

  /**
   * Get filtered consumables (only those with quantity <= 0 if filter is active)
   */
  getFilteredConsumables(consumables: any): any {
    if (!consumables) {
      return {};
    }
    
    if (!this.showOnlyMissing) {
      return consumables;
    }
    
    const filtered: any = {};
    for (const key in consumables) {
      if (consumables.hasOwnProperty(key) && consumables[key] <= 0) {
        filtered[key] = consumables[key];
      }
    }
    return filtered;
  }

  /**
   * Check if consumable value is <= 0 (for template type safety)
   */
  isValueZeroOrLess(value: any): boolean {
    return typeof value === 'number' && value <= 0;
  }

  ngOnDestroy() {
    if (this.directionSubscription) {
      this.directionSubscription.unsubscribe();
    }
    if (this.authStatusSub) {
      this.authStatusSub.unsubscribe();
    }
  }

  // ===============
}
